// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"3b53517f","549":"6b4c29cf","703":"6b4c29cf"}[chunkId] + ".chunk.css";
};